// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';

import style from './ProductsLimits.scss';
import btnStyles from '../../../../assets/styles/button.scss';
import Modal from '../../../../elements/Modal/Modal';

import type { LocaleState } from '../../../locale/duck';
import icons from '../../../../assets/styles/icons.scss';

type Props = {
  +localeState: LocaleState;
  +isSale?: boolean;
};

type State = {
  productLimitsModalVisible: boolean;
};

const limitsPE: { intl: string, number: number }[] = [
  { intl: 'flight.requests.productLimits.modal.table.laptop', number: 1 },
  { intl: 'flight.requests.productLimits.modal.table.camera', number: 1 },
  { intl: 'flight.requests.productLimits.modal.table.cellphones', number: 2 },
  { intl: 'flight.requests.productLimits.modal.table.tablets', number: 1 },
  { intl: 'flight.requests.productLimits.modal.table.shoes', number: 4 },
  { intl: 'flight.requests.productLimits.modal.table.makeUp', number: 5 },
  { intl: 'flight.requests.productLimits.modal.table.lotions', number: 4 },
  { intl: 'flight.requests.productLimits.modal.table.perfumes', number: 4 },
  { intl: 'flight.requests.productLimits.modal.table.vitamins', number: 5 },
];

export default class ProductsLimits extends Component<Props, State> {
  state = {
    productLimitsModalVisible: false,
  };

  handleOpenModal = () => {
    this.setState({
      productLimitsModalVisible: true,
    });
  };

  handleCloseModal = () => {
    this.setState({
      productLimitsModalVisible: false,
    });
  };

  render() {
    const { localeState, isSale } = this.props;
    const { productLimitsModalVisible } = this.state;
    return (
      <Fragment>
        <section className={style.productsLimitsWrap}
                 onClick={this.handleOpenModal}>
          <i className={classNames(icons.symbolAlert, style.alert)}/>
          <FormattedMessage id="flight.requests.productLimits.title">{
            txt => <p className={classNames(style.question, { [style.isSale]: isSale })}>{txt}</p>
          }</FormattedMessage>
          <i className={classNames(icons.iconChevronRightMedium, style.chevron)}/>
        </section>
        <Modal handleClose={this.handleCloseModal}
               open={productLimitsModalVisible}
               big>
          <section className={style.productLimitsModalWrap}>
            <FormattedMessage id="flight.requests.productLimits.modal.title">{
              txt => <h3 className={style.productLimitsTitle}>{txt}</h3>
            }</FormattedMessage>
            <table>
              <thead>
              <tr>
                <th>
                  <FormattedMessage id="flight.requests.productLimits.modal.table.quantity">{
                    txt => <p>{txt}</p>
                  }</FormattedMessage>
                </th>
                <th>
                  <FormattedMessage id="flight.requests.productLimits.modal.table.products">{
                    txt => <p>{txt}</p>
                  }</FormattedMessage>
                </th>
              </tr>
              </thead>
              <tbody>
              {localeState.domainCountry === 'PE' &&
              limitsPE.map((limit: { intl: string, number: number }, i: number) => (
                <tr key={i}>
                  <td><p>{limit.number}</p></td>
                  <td>
                    <FormattedMessage id={limit.intl}>{
                      txt => <p>{txt}</p>
                    }</FormattedMessage>
                  </td>
                </tr>
              ))}
              </tbody>
            </table>
            <FormattedMessage id="flight.requests.productLimits.modal.help">{
              txt => <p className={style.productLimitsHelp}>{txt} <a
                href="mailto:hola@qempo.com?Subject=Hola%20Qempo,%20necesito%20ayuda.">hola@qempo.com</a></p>
            }</FormattedMessage>
          </section>
        </Modal>
      </Fragment>
    );
  }
}

ProductsLimits.propTypes = {
  localeState: PropTypes.object.isRequired,
  isSale: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/modules/flight/components/ProductsLimits/ProductsLimits.jsx